import { EVillageRequestType } from '../../types/villageRequestType';
export var VILLAGE_REQUEST_TYPE_ANSWERS = [{
  label: 'Добавить коттеджный поселок в каталог',
  value: EVillageRequestType.AddingVillage
}, {
  label: 'Внести изменения в информацию о коттеджном поселке',
  value: EVillageRequestType.EditingVillage
}];